import { localeCompareAlphanumeric } from '@/utils/base'

export default {
  teamMemberships: (state) => state.teamMemberships,
  teamMembershipsLoading: (state) => state.teamMembershipsLoading,
  allTeams: (state) => state.teams?.sort((a, b) => a.isActive === b.isActive ? localeCompareAlphanumeric(a.name, b.name) : a.isActive ? -1 : 1),
  teamsLoading: (state) => state.teamsLoading
}
